import { contract } from './contract';

export const bool = contract<boolean>('boolean');
